export default __webpack_public_path__ + "static/media/a4.9a8d119e.png";